export default __webpack_public_path__ + "static/13_29-2e85916a3f6aa5591fd90759046e50c9.png";